// Event names published by the backend over Ably (`channel.publish(event, …)`),
// read off `message.name`, and persisted on notifications as `event`. Values must
// match the backend event strings exactly. Shared by the realtime service, the
// notifications store, and the notification center.
export enum RealtimeEvent {
  Card3dsValidationRequested = 'card_3ds_validation_requested',
  DashboardInvalidated = 'dashboard_invalidated',
  PaymentAccountCredited = 'payment_account_credited',
  // TT-6891 — digital wallet token lifecycle. Confirm the exact backend event
  // string in Phase 0 before relying on it in production.
  DigitalWalletTokenTransition = 'digital_wallet_token_transition',
}
